import {LoadingSkeleton} from '@/components/app/feedback';
import {Form} from '../../../app/components/Form';
import {useGetBiotwinSettingsQuery, useSetBiotwinSettingsMutation} from '../../../app/services/biotwinSettingsApi';
import {useSession} from '../../auth/hooks/useSession';
import {BiotwinSettings} from '../types';
import {defaultBiotwinSettings} from '../utils';
export interface BiotwinSettingsFormProps {
  userId: number;
}
export const BiotwinSettingsForm = ({userId}: BiotwinSettingsFormProps) => {
  const session = useSession();
  const {
    data: biotwinSettings,
    isLoading,
    isUninitialized,
  } = useGetBiotwinSettingsQuery(
    {
      userId,
    },
    {
      skip: !userId,
    },
  );
  const [setBiotwinSettings] = useSetBiotwinSettingsMutation();
  if (isUninitialized) {
    return null;
  }
  if (isLoading) {
    return (
      <div className={'flex flex-col gap-4 py-4'}>
        {Array.from({
          length: 4,
        }).map((_, index) => (
          <LoadingSkeleton height={'1.1875rem'} key={index} width={'18.375rem'} />
        ))}
      </div>
    );
  }
  return (
    <Form<BiotwinSettings>
      className="py-4"
      defaultValues={biotwinSettings ?? defaultBiotwinSettings}
      fields={[
        {
          label: 'Show pages about policy & standards',
          name: 'policyAndStandardPhrasesVisible',
          type: 'checkbox',
        },
        {
          label: 'Show hidden pages',
          name: 'hiddenPhrasesVisible',
          type: 'checkbox',
        },
        {
          label: 'Show redundant pages',
          name: 'duplicativePhrasesVisible',
          type: 'checkbox',
        },
        {
          label: 'Show PRO module',
          name: 'optionalModulesVisible',
          type: 'checkbox',
        },
      ]}
      onChange={(fieldValues) =>
        setBiotwinSettings({
          biotwinSettings: fieldValues,
          userId,
        })
      }
      render={({renderError, renderFieldByName, renderSubmitButton}) => (
        <>
          {renderError()}
          {renderFieldByName('policyAndStandardPhrasesVisible')}
          {renderFieldByName('hiddenPhrasesVisible')}
          {renderFieldByName('duplicativePhrasesVisible')}
          {session?.subscriptionType !== 'Free' &&
            session?.subscriptionType !== 'Pro' &&
            renderFieldByName('optionalModulesVisible')}
          {renderSubmitButton()}
        </>
      )}
      submitButton={false}
    />
  );
};
